export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const router = useRouter();
  const { GTM_KEY } = config.public;

  if (!GTM_KEY) {
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Add GTM script and noscript fallback
  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`,
        async: true,
      },
    ],
  });

  // Track page views on route changes
  router.afterEach((to) => {
    window.dataLayer.push({
      event: "pageview",
      page: {
        path: to.path,
        url: window.location.href,
      },
    });
  });
});
